export default "__VITE_ASSET__BLOAF5l0__"